import React, { useState } from "react";
import ImageWithBasePath from "../../../core/img/imagewithbasebath";
import { Link } from "react-router-dom";
import { all_routes } from "../../../Router/all_routes";
import { codeVerificationSSO } from '../../../apiwrapper/user.ts';
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

const TwostepverificationTwo = () => {
  const translation = useSelector(state => state.root.translation);
  const route = all_routes;
  // const [timeLeft, setTimeLeft] = useState(180); // 24 hours in seconds
  const [passwordError, setPasswordError] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  // useEffect(() => {
  //   const timer = setTimeout(() => {
  //     setTimeLeft(timeLeft - 1);
  //   }, 1000);

  //   // Clear timeout if component is unmounted or timeLeft becomes 0
  //   return () => clearTimeout(timer);
  // }, [timeLeft]);
  const handlePasswordChange = (index, value) => {
    const newPassword = [...password];
    newPassword[index] = value;
    setPassword(newPassword);
    if (value.length === 1 && index < 5) {
      document.getElementById(`digit-${index + 2}`).focus();
    }
    if (newPassword.join('').length === 6) {
      setPasswordError("");
    } else {
      setPasswordError("Password must be 6 digits long.");
    }
  };

  const handlePaste = (e) => {
    const paste = e.clipboardData.getData('text');
    if (paste.length === 6) {
      const newPassword = paste?.split('');
      setPassword(newPassword);
      setPasswordError("");
      newPassword.forEach((digit, index) => {
        document.getElementById(`digit-${index + 1}`).value = digit;
      });
    } else {
      setPasswordError("Pasted value must be exactly 6 digits.");
    }
    e.preventDefault();
  };

  // const handlePasswordChange = (index, value) => {
  //   const newPassword = [...password];
  //   newPassword[index] = value;
  //   setPassword(newPassword.join(''));
  //   if (newPassword.join('').length === 6) {
  //     setPasswordError("");
  //   } else {
  //     setPasswordError("Password must be 6 digits long.");
  //   }
  // };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if(password != '')
    {
      const passwordString = password.join('');
      if (passwordString.length !== 6) {
        setPasswordError(translation.password_length);
        return;
      }

      // Assuming your API call function is called 'resetPassword'
      const apiResponse = await codeVerificationSSO(passwordString); // Replace resetPassword with your API call function
      const data ={
        code:passwordString
      }
      if (apiResponse == '200') {
        navigate(route.resetpasswordTwo, { state: data });
      } else {
        setPasswordError(apiResponse);
        console.log("API error");
      }
    }
  };

  // const renderTimer = () => {
    // const hours = Math.floor(timeLeft / 3600);
    // const minutes = Math.floor((timeLeft % 3600) / 60);
    // const seconds = timeLeft % 60;

    // return (
    //   <div className="Otp-expire text-center">
    //     <p>Otp will expire in {minutes.toString().padStart(2, "0")} : {seconds.toString().padStart(2, "0")}</p>
    //   </div>
    // );
  // };

  return (
    <div className="main-wrapper">
      <div className="account-content">
        <div className="login-wrapper">
          <div className="login-img">
            <ImageWithBasePath src="assets/img/authentication/login02.png" alt="img" />
          </div>
          <div className="login-content">
            <div className="login-userset">
              <div className="login-userset">
                <div className="login-logo logo-normal">
                  <ImageWithBasePath src="assets/img/logo.png" alt="img" />
                </div>
              </div>
              <Link to={route.dashboard} className="login-logo logo-white">
                <ImageWithBasePath src="assets/img/logo-white.png" alt />
              </Link>
              <div className="login-userheading">
                <h3>{translation?.signin_with_email}</h3>
                <h4 className="verfy-mail-content">
                {translation?.code_sent}
                </h4>
              </div>
              <form onSubmit={handleSubmit} className="digit-group" onPaste={handlePaste}>
                <div className="wallet-add">
                  <div className="otp-box">
                    <div className="forms-block text-center">
                      {[1, 2, 3, 4, 5, 6].map(index => (
                        <input
                          key={index}
                          type="text"
                          id={`digit-${index}`}
                          maxLength={1}
                          onChange={(e) => handlePasswordChange(index - 1, e.target.value)}
                        />
                      ))}
                    </div>
                  </div>
                </div>
                {passwordError && <div className="error-message text-danger">{passwordError}</div>}
                {/* {renderTimer()} */}
                <div className="form-login mt-4">
                  <button type="submit" className="btn btn-login">
                  {translation?.verify_my_account}
                  </button>
                </div>
              </form>
              <div className="my-4 d-flex justify-content-center align-items-center copyright-text">
                <p>{translation?.copyright_message}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TwostepverificationTwo;
